import { LRS_URL } from 'constants/index';
import type { Transaction } from 'models/transaction';
import { fetchJson } from 'utils/fetchJson/fetchJson';

type UploadLrsRequestBody = {
  paymentId: string;
  paymentToken: string;
  bankAccountNumber: string;
  studentFullName: string;
  studentID: string;
  transactions: Transaction[];
  signatureImage: string;
};

const lrs = {
  upload: (payload: UploadLrsRequestBody) => {
    const body = JSON.stringify({
      bank_account_number: payload.bankAccountNumber,
      payment_id: payload.paymentId,
      payment_token: payload.paymentToken,
      signature_image: payload.signatureImage,
      student_full_name: payload.studentFullName,
      student_id: payload.studentID,
      transactions: parseTransactions(payload.transactions),
    });

    return fetchJson(`${LRS_URL}/upload`, { method: 'POST', body });
  },
};

const parseTransactions = (transactions: Transaction[]) => {
  if (!transactions?.length) {
    return null;
  }

  return transactions.map(({ adBranch, ...transaction }) => ({
    ...transaction,
    address: adBranch,
  }));
};

export { lrs };
